import React, { Fragment, Suspense } from 'react';
import cx from 'classnames';
import styles from './AuthorBio.module.scss';
import { t } from '@konrad/reweb-aem';
import PropTypes from 'prop-types';
import { SocialMediaRow } from '../_shared';
import { Heading, LinkBase, Text } from '../index';
import { ContentWithMedia } from '../lazyComponents';
import PostList from '../PostList';

const AuthorBio = (props) => {
    const { author, description, image, posts, areasOfExpertise, twitterLink, linkedinLink } =
        props;

    return (
        <div className={cx(styles.root, 'light-theme')} role="table">
            <Suspense fallback={''}>
                <ContentWithMedia
                    altText={t('fs.author-bio.picture')}
                    mediaType="image"
                    fileReference={image}
                    graphicalElement={'purple-corners'}
                    desktopPosition={'media-left'}
                    mobilePosition={'media-above'}
                >
                    <Heading
                        className={cx(styles['author-name'])}
                        text={author}
                        headingLevel="h1"
                    />
                    <SocialMediaRow linkedin={linkedinLink} twitter={twitterLink} />
                    <Text content={description} />
                    {areasOfExpertise && (
                        <div className={cx(styles['author-expertise-wrapper'])}>
                            <Text
                                className={cx(styles['author-expertise-title'])}
                                size={'body'}
                                content={t('fs.author-bio.expertise') + ':'}
                            />
                            {areasOfExpertise.map((item, i) => (
                                <Fragment key={`areas-of-expertise-${i}`}>
                                    <LinkBase
                                        addIdSuffix={true}
                                        target={'internal'}
                                        url={item.link}
                                        className={cx(styles['author-expertise-link'])}
                                        altText={item.title}
                                    >
                                        <span>
                                            {item.title}
                                            {i < areasOfExpertise.length - 1 && ','}
                                        </span>
                                    </LinkBase>
                                </Fragment>
                            ))}
                        </div>
                    )}
                </ContentWithMedia>
            </Suspense>
            {!!posts.length && (
                <Suspense fallback={''}>
                    <Text
                        className={cx(styles['blogs-title'])}
                        size={'x-large'}
                        content={t('fs.author-bio.blogs-by', [author])}
                    />
                    <PostList
                        morePostsCtaAltText={t('fs.author-bio.view-more')}
                        morePostsCtaText={t('fs.author-bio.view-more')}
                        postLinkType={'internal'}
                        postCategoryHeadingLevel={'h3'}
                        posts={posts}
                        postTitleHeadingLevel={'h2'}
                    />
                </Suspense>
            )}
        </div>
    );
};

AuthorBio.displayName = 'AuthorBio';

AuthorBio.propTypes = {
    author: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string.isRequired,
    posts: PropTypes.arrayOf(
        PropTypes.shape({
            altText: PropTypes.string.isRequired,
            category: PropTypes.string.isRequired,
            date: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            image: PropTypes.string.isRequired,
            readTime: PropTypes.number,
            postUrl: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        })
    ),
    areasOfExpertise: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
        })
    ),
    twitterLink: PropTypes.string,
    linkedinLink: PropTypes.string,
};

export default AuthorBio;
